import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import PatientCountCell from '../../../../components/patient-count-cell/PatientCountCell';

const PurbaPanchaKarmaReport = (props) => {
  return (
    <>
      <TableContainer classes={{ root: "fixed-head-table-container" }}  >
        <Typography variant="body1" className="report-heading">पूर्वपञ्चकर्म प्रतिवेदन</Typography>
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Ksharasutra-Sewa-Report">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell rowSpan={4} colSpan={2}> सेवाको विवरण</TableCell>
              <TableCell rowSpan={4}>उमेर</TableCell>
              <TableCell rowSpan={4}>दीपन ∕  पाचन</TableCell>
              <TableCell colSpan={3}>स्नेहन</TableCell>
              <TableCell colSpan={2} rowSpan={2}>स्वेदन</TableCell>
            </TableRow>
            <TableRow>
              <TableCell rowSpan={3}>आभ्यन्तर</TableCell>
              <TableCell colSpan={2} rowSpan={2}>बाह्य</TableCell>
            </TableRow>
            <TableRow>
              <TableCell rowSpan={2}>एकाङ्ग</TableCell>
              <TableCell rowSpan={2}>सर्वाङ्ग</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>एकाङ्ग</TableCell>
              <TableCell>सर्वाङ्ग</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            <TableRow>
              <TableCell rowSpan={4}>सेवाग्राही संख्या </TableCell>
              <TableCell rowSpan={2}>महिला</TableCell>
              <TableCell>&lt;60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.["<60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.["<60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.["<60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.["<60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.["<60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.["<60"]["4.2"]} />
            </TableRow>
            <TableRow>
              <TableCell>&ge;=60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.[">60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.[">60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.[">60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.[">60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.[">60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.FEMALE?.[">60"]["4.2"]} />
            </TableRow>
            <TableRow>
              <TableCell rowSpan={2}>पुरुष</TableCell>
              <TableCell>&lt;60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.["<60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.["<60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.["<60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.["<60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.["<60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.["<60"]["4.2"]} />
            </TableRow>
            <TableRow>
              <TableCell>&ge;=60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.[">60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.[">60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.[">60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.[">60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.[">60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.PATIENT_COUNT?.MALE?.[">60"]["4.2"]} />
            </TableRow>
            <TableRow>
              <TableCell rowSpan={4}>सेवा संख्या </TableCell>
              <TableCell rowSpan={2}>महिला</TableCell>
              <TableCell>&lt;60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.["<60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.["<60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.["<60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.["<60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.["<60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.["<60"]["4.2"]} />
            </TableRow>
            <TableRow>
              <TableCell>&ge;=60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.[">60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.[">60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.["<60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.[">60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.[">60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.FEMALE?.[">60"]["4.2"]} />
            </TableRow>
            <TableRow>
              <TableCell rowSpan={2}>पुरुष</TableCell>
              <TableCell>&lt;60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.["<60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.["<60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.["<60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.["<60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.["<60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.["<60"]["4.2"]} />
            </TableRow>
            <TableRow>
              <TableCell>&ge;=60</TableCell>
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.[">60"]["1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.[">60"]["2"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.[">60"]["3"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.[">60"]["4"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.[">60"]["4.1"]} />
              <PatientCountCell data={props.tableData?.PURBA_KARMA?.SERVICE_COUNT?.MALE?.[">60"]["4.2"]} />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default PurbaPanchaKarmaReport;
